import { ListButton, useCreateContext, useEditContext } from "react-admin";
import { useQueryParams } from "../../../common/hooks/useQueryParams";

interface Props {
  onClose?: () => void;
  basePath?: string;
}

export const EventMasterFormActions = ({ onClose, ...rest }: Props) => {
  const params = useQueryParams();
  const editCtx = useEditContext();
  const createCtx = useCreateContext();
  const source = JSON.parse(params.get("source") ?? "{}");
  const driverId =
    editCtx.record?.driverId ?? createCtx.record?.driverId ?? source.driverId;
  const date = editCtx.record?.date ?? createCtx.record?.date ?? source.date;
  let basePath = rest.basePath;
  if (driverId && date) {
    basePath = `/hos-driver-log-view/${driverId}/${date}`;
  }

  return (
    <>
      <ListButton
        basePath={basePath}
        label="resources.common.labels.backToList"
        onClick={() => {
          if (onClose) onClose();
        }}
      />
    </>
  );
};
